import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'
import { Navigate, useParams } from 'react-router'

import { $account } from '@/models/account.ts'
import { CreatorAccessEdit } from '@/modules/creators/views/edit-access'
import { AppRoutes } from '@/utils/constants'

export const CreatorsAccessView = () => {
  const { id } = useParams<{ id?: string }>()
  const account = useUnit($account)

  const isPageAccessible = [TeamMemberRole.ADMIN, TeamMemberRole.LEADER].some(
    (role) => role === account?.memberRole,
  )

  if (!id || !isPageAccessible) {
    return <Navigate to={AppRoutes.Creators.List.asUrl()} />
  }

  return <CreatorAccessEdit id={+id} />
}
